import Reveal from "@/components/Reveal";

export const Section = ({
  id,
  eyebrow,
  title,
  intro,
  tone = "cream",
  align = "left",
  className = "",
  headerClassName = "",
  children,
}) => {
  const tones = {
    cream: "bg-cream text-cocoa",
    surface: "bg-surface text-cocoa",
    sage: "bg-sageSoft text-cocoa",
    forest: "bg-forest text-white",
    coral: "bg-coralInk text-white",
    creamDeep: "bg-creamDeep text-cocoa",
  };
  const onDark = tone === "coral" || tone === "forest";

  return (
    <section
      id={id}
      data-testid={id ? `section-${id}` : undefined}
      className={`relative overflow-hidden ${tones[tone]} py-20 sm:py-24 lg:py-32 ${className}`}
    >
      {onDark && (
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage:
              tone === "coral"
                ? "radial-gradient(70% 60% at 12% 0%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0) 62%)"
                : "radial-gradient(70% 60% at 12% 0%, rgba(246,136,37,0.22) 0%, rgba(246,136,37,0) 62%)",
          }}
        />
      )}
      <div className="mbm-container relative">
        {(eyebrow || title || intro) && (
          <Reveal
            className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} ${headerClassName}`}
          >
            {eyebrow && (
              <p
                className="mbm-eyebrow"
                style={onDark ? { color: "#FFFFFF" } : undefined}
              >
                {eyebrow}
              </p>
            )}
            {title && (
              <h2
                className="mt-5 font-heading text-[2rem] font-bold leading-[1.08] tracking-[-0.015em] sm:text-[2.5rem] lg:text-[3.1rem]"
                style={onDark ? { color: "#FFFFFF" } : undefined}
              >
                {title}
              </h2>
            )}
            {intro && (
              <p
                className={`mt-5 max-w-2xl text-sm font-medium leading-relaxed sm:text-base ${
                  align === "center" ? "mx-auto" : ""
                }`}
                style={
                  onDark
                    ? { color: "#FFFFFF" }
                    : { color: "rgba(46,38,38,0.8)" }
                }
              >
                {intro}
              </p>
            )}
          </Reveal>
        )}
        {children}
      </div>
    </section>
  );
};

export const PageHero = ({ eyebrow, title, intro, children }) => (
  <section className="mbm-warm-wash relative overflow-hidden bg-cream">
    <div
      aria-hidden="true"
      className="mbm-petal pointer-events-none absolute -right-24 -top-24 hidden h-[26rem] w-[26rem] bg-gradient-to-br from-forest/12 to-amber/10 lg:block"
    />
    <div className="mbm-container relative py-16 sm:py-20 lg:py-24">
      <Reveal className="max-w-3xl">
        {eyebrow && <p className="mbm-eyebrow">{eyebrow}</p>}
        <h1 className="mt-5 font-heading text-[2.2rem] font-bold leading-[1.06] tracking-[-0.015em] sm:text-[3rem] lg:text-[3.6rem]">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 max-w-2xl text-sm font-medium leading-relaxed text-cocoa/72 sm:text-base">
            {intro}
          </p>
        )}
        {children && <div className="mt-9">{children}</div>}
      </Reveal>
    </div>
    <div aria-hidden="true" className="mbm-squiggle" />
  </section>
);

export default Section;
